import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.82, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLines = ({ lines, delay = 0, stagger = 0.1, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className={`block overflow-hidden pb-[0.08em] ${className}`}>
          <motion.span
            className="block will-change-transform"
            initial={reduce ? false : { y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const ParallaxImg = ({ src, alt = "", className = "", speed = 8 }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed}%`, `${speed}%`]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        style={{ y: reduce ? "0%" : y }}
        className="absolute inset-0 h-full w-full scale-[1.2] object-cover"
      />
    </div>
  );
};

export const Marquee = ({ items }) => (
  <div className="marquee overflow-hidden border-y border-white/10 py-7">
    <motion.div className="marquee-track flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="marquee-copy flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-2xl font-semibold uppercase tracking-wide text-white/75 sm:text-3xl">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </motion.div>
  </div>
);
